function contentHeight(){
    let height = $(window).height() - $('.main-header').outerHeight() + 'px';
   
    return height;
}

export{
    contentHeight
}




// WEBPACK FOOTER //
// ./src/util/rem.js